import keys from '@debbie/common/dist/cache/keys.js';
import { CaseVoucherSource, State, } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { Currency, Entity } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import { delCaseVoucher, patchCaseVoucher, } from '@debbie/cortex/dist/api/case-vouchers.js';
import { caseVouchersEntity, useCaseVouchers, } from '@debbie/cortex/dist/case-vouchers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import Badge from './Badge.js';
import Button from './Button.js';
import CasePreview from './CasePreview/index.js';
import { BookingDateFilter, bookingDateValue, } from './economy/case-vouchers/BookingDate.js';
import CaseVoucherExport from './economy/case-vouchers/CaseVoucherExport.js';
import { X } from './Icons/index.js';
import Modal from './Modal.js';
import Money from './Money.js';
import * as filters from './power-table/Filters.js';
import RemoteTable from './RemoteTable.js';
import Search from './Search.js';
import Timestamp from './Timestamp.js';
const VoucherTypeFilter = (props) => {
    const lang = useSelector((s) => s.lang);
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : [];
    return (React.createElement(filters.CategoryFilter, { categories: objectBy(voucherTypes
            .filter((voucherType) => CaseVoucherCategories.includes(voucherType.category))
            .map((voucherType) => {
            return {
                id: voucherType.voucherTypeId,
                label: lang.economyVoucherTypeLabels[voucherType.voucherTypeId] ||
                    voucherType.label,
            };
        }), (ctx) => ctx.id), selected: props.filter.voucherTypeIds != null ? props.filter.voucherTypeIds : [], onChange: (ids) => {
            props.setFilter({
                ...props.filter,
                voucherTypeIds: ids.length > 0 ? ids : undefined,
            });
        } }));
};
const CaseVoucherTable = (props) => {
    const lang = useSelector((s) => s.lang);
    const [selected, setSelected] = useState([]);
    const [exportFilter, setExportFilter] = useState({});
    const [mapperModalOpen, setMapperModalOpen] = useState(false);
    const [mapperCaseVoucher, setMapperCaseVoucher] = useState(undefined);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteCaseVoucher, setDeleteCaseVoucher] = useState(undefined);
    const excludedFilters = props.excludeFilter ?? [];
    return (React.createElement("div", null,
        props.selectable ? (React.createElement(CaseVoucherExport, { selectedIds: selected, filter: { ...exportFilter, ...props.filter }, onExport: () => q.invalidate(keys.write.create(caseVouchersEntity)) })) : null,
        React.createElement(RemoteTable, { useFetch: (filters, page, pageSize) => useCaseVouchers({ ...filters, ...props.filter }, page, pageSize), selectable: props.selectable, selectKey: (cv) => cv.caseVoucherId, onSelect: setSelected, selected: selected, genKey: (cv) => cv.caseVoucherId, sortKeyKey: "sortKey", sortDirectionKey: "sortDirection", initFilters: {}, onFilterChange: setExportFilter, pageSize: props.pageSize, values: {
                id: {
                    label: lang.economy.voucherInfoId,
                    width: '100px',
                },
                voucherTypeId: {
                    label: lang.misc.type,
                    width: '150px',
                    map: (type, caseVoucher) => {
                        return type
                            ? lang.economyVoucherTypeLabels[type] ||
                                caseVoucher.label
                            : '';
                    },
                    sortable: false,
                    ...(!excludedFilters.includes('voucherTypeId')
                        ? {
                            filter: VoucherTypeFilter,
                            filterActive: (filter) => filter.voucherTypeIds != null &&
                                filter.voucherTypeIds.length > 0,
                        }
                        : {
                            filter: undefined,
                            filterActive: undefined,
                        }),
                },
                date: {
                    label: lang.misc.date,
                    map: (x) => React.createElement(Timestamp, { date: x }),
                    ...(!excludedFilters.includes('date')
                        ? {
                            filter: (props) => (React.createElement(filters.DateRangeFilter, { from: props.filter.fromDate ?? null, to: props.filter.toDate ?? null, onChange: (fromDate, toDate) => {
                                    props.setFilter({
                                        ...props.filter,
                                        fromDate: fromDate ?? undefined,
                                        toDate: toDate ?? undefined,
                                    });
                                } })),
                            filterActive: (filter) => filter.fromDate != null || filter.toDate != null,
                        }
                        : {
                            filter: undefined,
                            filterActive: undefined,
                        }),
                },
                bookingDate: {
                    label: lang.caseVouchers.bookingDate,
                    // Sorting would have to be on the effective booking date, which is
                    // not one of the columns the API accepts as a sort key
                    sortable: false,
                    map: bookingDateValue,
                    ...(!excludedFilters.includes('bookingDate')
                        ? {
                            filter: BookingDateFilter,
                            filterActive: (filter) => filter.fromBookingDate != null ||
                                filter.toBookingDate != null,
                        }
                        : {
                            filter: undefined,
                            filterActive: undefined,
                        }),
                },
                text: {
                    label: lang.misc.text,
                    sortable: false,
                    width: '150px',
                },
                source: {
                    label: lang.caseVouchers.source,
                    map: (k) => lang.caseVoucherSources[k],
                    ...(!excludedFilters.includes('source')
                        ? {
                            filter: (props) => {
                                return (React.createElement(filters.CategoryFilter, { categories: objectBy(Object.values(CaseVoucherSource).map((source) => {
                                        return {
                                            id: source,
                                            label: lang.caseVoucherSources[source],
                                        };
                                    }), (ctx) => ctx.id), selected: props.filter.sources != null
                                        ? props.filter.sources
                                        : [], onChange: (ids) => {
                                        props.setFilter({
                                            ...props.filter,
                                            sources: ids.length > 0
                                                ? ids
                                                : undefined,
                                        });
                                    } }));
                            },
                            filterActive: (filter) => filter.sources != null && filter.sources.length > 0,
                        }
                        : { filter: undefined, activeFilter: undefined }),
                },
                state: {
                    label: lang.misc.state,
                    sortable: false,
                    map: (state) => state ? (React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.caseVoucherStates[state])) : (''),
                    ...(!excludedFilters.includes('state')
                        ? {
                            filter: (props) => {
                                return (React.createElement(filters.CategoryFilter, { categories: objectBy(Object.values(State).map((state) => {
                                        return {
                                            id: state,
                                            label: lang.caseVoucherStates[state],
                                        };
                                    }), (ctx) => ctx.id), selected: props.filter.states != null ? props.filter.states : [], onChange: (states) => {
                                        props.setFilter({
                                            ...props.filter,
                                            states: states.length > 0
                                                ? states
                                                : undefined,
                                        });
                                    } }));
                            },
                            filterActive: (filter) => filter.states != null && filter.states.length > 0,
                        }
                        : {
                            filter: undefined,
                            filterActive: undefined,
                        }),
                },
                amount: {
                    label: lang.economy.amount,
                    map: (amount) => React.createElement(Money, { color: true, amount: amount }),
                    align: 'right',
                    ...(!excludedFilters.includes('amount')
                        ? {
                            filter: (props) => (React.createElement("div", null,
                                React.createElement(filters.MoneyRangeFilter, { from: props.filter.fromAmount ?? null, to: props.filter.toAmount ?? null, onChange: (fromAmount, toAmount) => {
                                        props.setFilter({
                                            ...props.filter,
                                            fromAmount: fromAmount ?? undefined,
                                            toAmount: toAmount ?? undefined,
                                        });
                                    } }))),
                            filterActive: (filter) => filter.fromAmount != null || filter.toAmount != null,
                        }
                        : {
                            filter: undefined,
                            filterActive: undefined,
                        }),
                },
                currency: {
                    label: lang.economy.currency,
                    map: (c) => React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, c),
                    ...(!excludedFilters.includes('currency')
                        ? {
                            filter: (props) => {
                                return (React.createElement("div", null,
                                    React.createElement(filters.CategoryFilter, { categories: objectBy(Object.values(Currency).map((currency) => {
                                            return {
                                                id: currency,
                                                label: currency,
                                            };
                                        }), (ctx) => ctx.id), selected: props.filter.currencies != null
                                            ? props.filter.currencies
                                            : [], onChange: (ids) => {
                                            props.setFilter({
                                                ...props.filter,
                                                currencies: ids.length > 0
                                                    ? ids
                                                    : undefined,
                                            });
                                        } })));
                            },
                            filterActive: (filter) => filter.currencies != null && filter.currencies.length > 0,
                        }
                        : { filter: undefined, filterActive: undefined }),
                },
                expirationDate: {
                    label: lang.caseVouchers.expirationDate,
                    map: (d) => (d ? React.createElement(Timestamp, { date: d }) : ''),
                    ...(!excludedFilters.includes('expirationDate')
                        ? {
                            filter: (props) => (React.createElement("div", null,
                                React.createElement(filters.DateRangeFilter, { from: props.filter.fromExpirationDate ?? null, to: props.filter.toExpirationDate ?? null, onChange: (fromDate, toDate) => {
                                        props.setFilter({
                                            ...props.filter,
                                            fromExpirationDate: fromDate ?? undefined,
                                            toExpirationDate: toDate ?? undefined,
                                        });
                                    } }))),
                            filterActive: (filter) => filter.fromExpirationDate != null ||
                                filter.toExpirationDate != null,
                        }
                        : { filter: undefined, filterActive: undefined }),
                },
                expired: {
                    label: lang.caseVouchers.expired,
                    map: (expired) => (expired ? lang.misc.yes : lang.misc.no),
                    filter: (props) => {
                        return (React.createElement(filters.BooleanFilter, { filter: {
                                showTrue: props.filter.expired,
                            }, onChange: (filter) => {
                                props.setFilter({
                                    ...props.filter,
                                    expired: filter.showTrue,
                                });
                            } }));
                    },
                    filterActive: (filter) => filter.expired != null,
                },
                irrecoverableDate: {
                    ...(!excludedFilters.includes('irrecoverableDate')
                        ? {
                            filterActive: (filter) => {
                                return (filter.fromIrrecoverableDate != null ||
                                    filter.toIrrecoverableDate != null);
                            },
                            filter: (props) => (React.createElement("div", null,
                                React.createElement(filters.DateRangeFilter, { from: props.filter.fromIrrecoverableDate ?? null, to: props.filter.toIrrecoverableDate ?? null, onChange: (fromDate, toDate) => {
                                        props.setFilter({
                                            ...props.filter,
                                            fromIrrecoverableDate: fromDate ?? undefined,
                                            toIrrecoverableDate: toDate ?? undefined,
                                        });
                                    } }))),
                        }
                        : { filter: undefined, filterActive: undefined }),
                    label: lang.caseVouchers.irrecoverableDate,
                    map: (d) => (d ? React.createElement(Timestamp, { date: d }) : ''),
                },
                createdAt: {
                    label: lang.misc.createdAt,
                    map: (date, cv) => React.createElement(Timestamp, { date: date }),
                },
                caseId: {
                    label: lang.caseVouchers.case,
                    map: (caseId, cv) => caseId ? (React.createElement(CasePreview, { caseId: caseId })) : (React.createElement("div", { style: { display: 'flex', gap: 4 } },
                        React.createElement(Button, { onClick: () => {
                                setMapperCaseVoucher(cv.caseVoucherId);
                                setMapperModalOpen(true);
                            }, size: "small" }, lang.caseVouchers.map),
                        props.deleteable && (React.createElement(Button, { size: "small", theme: "dangerous", onClick: () => {
                                setDeleteCaseVoucher(cv.caseVoucherId);
                                setDeleteModalOpen(true);
                            } }, lang.misc.delete)))),
                    width: '120px',
                    sortable: false,
                },
            } }),
        mapperModalOpen && mapperCaseVoucher ? (React.createElement(Modal, { maxWidth: "400px", onToggle: () => setMapperModalOpen(false), header: lang.caseVouchers.mapHeader },
            React.createElement(CaseSelector, { caseVoucherId: mapperCaseVoucher, onSubmit: () => {
                    setMapperCaseVoucher(undefined);
                    setMapperModalOpen(false);
                } }))) : null,
        deleteModalOpen && deleteCaseVoucher && (React.createElement(Modal, { maxWidth: "400px", onToggle: () => setDeleteModalOpen(false), header: lang.economy.voucherInfoDeleteVoucher },
            React.createElement(CaseVoucherDeleteModal, { caseVoucherId: deleteCaseVoucher, onSubmit: () => {
                    setDeleteModalOpen(false);
                    setDeleteCaseVoucher(undefined);
                } })))));
};
const CaseVoucherDeleteModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const model = useMutation((caseVoucherId) => delCaseVoucher(caseVoucherId), {
        onSuccess: (res, caseVoucherId) => {
            q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucherId));
            if (props.onSubmit) {
                props.onSubmit();
            }
        },
        onError: (err) => {
            errorNotification(lang, err, 'delete', lang.errorEntities.caseVoucher);
        },
    });
    return (React.createElement("div", null,
        React.createElement("p", null, lang.caseVouchers.deleteWarning),
        React.createElement("div", { style: { display: 'flex', gap: 4 } },
            React.createElement(Button, { theme: "dangerous", style: { width: '100%' }, loading: model.isLoading, onClick: () => {
                    model.mutate(props.caseVoucherId);
                } }, lang.misc.delete),
            React.createElement(Button, { theme: "secondary", style: { width: '100%' }, loading: model.isLoading, onClick: () => {
                    props.onSubmit && props.onSubmit();
                } }, lang.misc.cancel))));
};
const CaseSelector = (props) => {
    const lang = useSelector((s) => s.lang);
    const [caseCtx, setCaseCtx] = useState(null);
    const model = useMutation((caseVoucherId, caseId) => patchCaseVoucher(caseVoucherId, {
        caseId,
    }), {
        onSuccess: (res, caseVoucherId) => {
            q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucherId));
            if (props.onSubmit) {
                props.onSubmit();
            }
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.caseVoucher);
        },
    });
    return (React.createElement("div", null,
        caseCtx ? (React.createElement(SelectedCase, null,
            React.createElement(CasePreview, { caseId: caseCtx.id }),
            React.createElement(X, { style: { cursor: 'pointer' }, onClick: () => {
                    setCaseCtx(null);
                } }))) : (React.createElement(Search, { removeWrapper: true, entity: Entity.Case, onSelect: (result) => {
                setCaseCtx(result);
            } })),
        React.createElement(Button, { style: { width: '100%' }, disabled: caseCtx == null, loading: model.isLoading, onClick: () => {
                if (caseCtx?.id) {
                    model.mutate(props.caseVoucherId, caseCtx.id);
                }
            } }, lang.caseVouchers.map)));
};
const SelectedCase = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1em;
  margin-bottom: 1em;
  background: #ddd;
  border-radius: 3px;
`;
export default CaseVoucherTable;
//# sourceMappingURL=CaseVoucherTable.js.map